module.exports = __webpack_public_path__ + "assets/img/77@3x.4a296323.png";